import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { styleClasses } from "../../helpers";
import { SVGSources } from "./SVGSources";
const CSS_PREFIX = `lav-components-logo`;
const DEFAULT_HEIGHTS = {
    appIconRound: 256,
    appIconRoundSquare: 256,
    logomark: 131.794,
    logotype: 170.765,
    stampLogotype: 275.422,
    lavenderBrand: 242,
};
const DEFAULT_WIDTHS = {
    appIconRound: 256,
    appIconRoundSquare: 256,
    logomark: 152,
    logotype: 1837.14,
    stampLogotype: 1690.47,
    lavenderBrand: 1640.23,
};
export const Logo = (_a) => {
    var { className = "", variant, height = DEFAULT_HEIGHTS[variant], style } = _a, divProps = __rest(_a, ["className", "variant", "height", "style"]);
    const scale = height / DEFAULT_HEIGHTS[variant];
    return (_jsx("div", Object.assign({ className: classNames(styleClasses(CSS_PREFIX, { variant }), {
            [className]: !!className,
        }), style: Object.assign(Object.assign({}, style), { height, width: DEFAULT_WIDTHS[variant] * scale }) }, divProps, { children: _jsx("img", { src: SVGSources[variant], style: {
                transform: `scale(${scale})`,
                transformOrigin: "left top",
            } }) })));
};
